import { GET_LIST_POLICIES } from '../../constants/actions/policies';

export function getListPolicies(payload) {
    return {
        type: GET_LIST_POLICIES,
        payload,
    };
}
